/* jscs:disable disallowArrayDestructuringReturn */
import { fitBounds } from 'google-map-react/utils';
import { isEmptyArray } from '../../../core/util/array';

const EPSILON = 0.000001;

const DEFAULT_SIZE = {
  height: 480,
  width: 640,
};

const DEFAULT_CENTER = {
  // dallas
  lat: 32.8205865,
  lng: -96.871626,
};

const coordsFromMarkers = markers => {
  const lats = markers.map(marker => parseFloat(marker.lat));
  const lngs = markers.map(marker => parseFloat(marker.lng));

  const ne = { lat: Math.max(...lats), lng: Math.max(...lngs) };
  const sw = { lat: Math.min(...lats), lng: Math.min(...lngs) };

  // if the coordinates are somehow equal to each other, fitBounds will return bad values
  if (ne.lat === sw.lat || ne.lng === sw.lng) {
    sw.lat -= EPSILON;
    sw.lng -= EPSILON;
  }

  return { ne, sw };
};

const coordsFromCenter = ({ lat, lng }) => ({
  ne: { lat, lng },
  sw: { lat: lat - EPSILON, lng: lng - EPSILON },
});

const getBounds = ({ markers, center }, containerSize) => {
  const hasMarkers = !isEmptyArray(markers);
  const coords = hasMarkers ? coordsFromMarkers(markers) : coordsFromCenter(center);

  const bounds = fitBounds(coords, containerSize);
  return {
    ...bounds,
    zoom: hasMarkers ? Math.max(Math.min(bounds.zoom, 14), 1) : 10,
  };
};

const calcSize = ref => {
  const container = ref.current;
  if (container) {
    return {
      height: container.clientHeight,
      width: container.clientWidth,
    };
  }

  return DEFAULT_SIZE;
};

export { DEFAULT_CENTER, getBounds, calcSize };
